import { combineReducers } from 'redux-immutable'

import ui from './ui'

export default combineReducers({
  ui
})
